__turbopack_context__.v({
  "defaultBadge": "TeamNewsTabs-module-scss-module__oUp03G__defaultBadge",
  "tabsList": "TeamNewsTabs-module-scss-module__oUp03G__tabsList",
});
